<section class="eco" id="technologies" #ecoRoot [class.is-in]="viewState() === 'shown'">
  <!-- ---------- background ---------- -->
  <div class="eco__bg" aria-hidden="true">
    <span class="eco__blob eco__blob--pink"></span>
    <span class="eco__blob eco__blob--violet"></span>
    <span class="eco__blob eco__blob--blue"></span>
    <span class="eco__grid-lines"></span>
    <svg class="eco__waves" viewBox="0 0 1440 620" fill="none" preserveAspectRatio="none">
      <defs>
        <linearGradient id="ecoWaveA" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stop-color="#ff2d95" stop-opacity="0" />
          <stop offset="45%" stop-color="#ff2d95" stop-opacity=".5" />
          <stop offset="100%" stop-color="#b14eff" stop-opacity="0" />
        </linearGradient>
        <linearGradient id="ecoWaveB" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stop-color="#3b82f6" stop-opacity="0" />
          <stop offset="52%" stop-color="#6c63ff" stop-opacity=".45" />
          <stop offset="100%" stop-color="#b14eff" stop-opacity="0" />
        </linearGradient>
      </defs>
      <path d="M0 120C240 40 520 24 760 96s400 120 680 44" stroke="url(#ecoWaveA)" stroke-width="1" />
      <path d="M0 190C240 110 520 94 760 166s400 120 680 44" stroke="url(#ecoWaveA)" stroke-width="1" />
      <path d="M0 470C260 560 560 590 820 520s380-104 620-38" stroke="url(#ecoWaveB)" stroke-width="1" />
      <path d="M0 540C260 630 560 660 820 590s380-104 620-38" stroke="url(#ecoWaveB)" stroke-width="1" />
    </svg>
    <span class="eco__particles">
      <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
      <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
    </span>
  </div>

  <div class="container eco__inner">
    <!-- ---------- header ---------- -->
    <header class="eco__head" [@headIn]="viewState()" [@.disabled]="reduced">
      <span class="eco__badge">
        <i aria-hidden="true"></i>
        Complete Digital Ecosystem
      </span>
      <h2 class="eco__title">
        Everything Your Business Needs.
        <span class="eco__title-grad">Connected.</span>
      </h2>
      <p class="eco__lede">
        Strategy, design, technology and growth — unified by ResilienceSoft.
      </p>
    </header>

    <!-- ======================= the ecosystem stage ======================= -->
    <div class="eco__stage" #stage [@stageIn]="viewState()" [@.disabled]="reduced">
      <!-- connectors, drawn from measured card geometry -->
      <svg
        class="eco__links"
        [attr.viewBox]="'0 0 ' + stageBox().w + ' ' + stageBox().h"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <g
          class="eco-link"
          *ngFor="let l of links(); trackBy: trackByLink"
          [attr.data-tone]="l.tone"
          [class.is-hot]="hot() === l.id"
        >
          <path class="eco-link__base" [attr.d]="l.d" />
          <path class="eco-link__flow" [attr.d]="l.d" [style.animation-delay]="l.delay" />
        </g>
      </svg>

      <!-- central hub -->
      <div class="eco-hub" #hub>
        <span class="eco-hub__halo" aria-hidden="true"></span>
        <span class="eco-hub__ring eco-hub__ring--1" aria-hidden="true"></span>
        <span class="eco-hub__ring eco-hub__ring--2" aria-hidden="true"></span>
        <span class="eco-hub__ring eco-hub__ring--3" aria-hidden="true"></span>
        <span class="eco-hub__orbit" aria-hidden="true"><i></i></span>
        <span class="eco-hub__orbit eco-hub__orbit--2" aria-hidden="true"><i></i></span>

        <span class="eco-hub__core">
          <span class="eco-hub__mark" role="img" aria-label="ResilienceSoft"></span>
          <strong class="eco-hub__name">ResilienceSoft</strong>
          <small class="eco-hub__role">Technology Partner</small>
        </span>
      </div>

      <!-- satellites -->
      <div
        class="eco-sat"
        *ngFor="let s of satellites; trackBy: trackBySat"
        #sat
        [attr.data-id]="s.card.id"
        [attr.data-tone]="s.card.tone"
        [style.grid-area]="s.slot"
        (mouseenter)="hot.set(s.card.id)"
        (mouseleave)="hot.set(null)"
        (focusin)="hot.set(s.card.id)"
        (focusout)="hot.set(null)"
      >
        <app-eco-card [card]="s.card"></app-eco-card>
      </div>
    </div>

    <!-- ================= platforms + outcomes ================= -->
    <div class="eco__band" [@staggerIn]="viewState()" [@.disabled]="reduced">
      <div class="eco__plat eco-stagger">
        <h3 class="eco__plat-title">Platforms &amp; Technologies</h3>
        <ul class="eco__chips">
          <li *ngFor="let p of platforms; trackBy: trackByName">{{ p }}</li>
        </ul>
      </div>

      <div class="eco__bene">
        <app-eco-card
          class="eco-stagger"
          *ngFor="let b of benefits; trackBy: trackById"
          [card]="b"
          variant="compact"
        ></app-eco-card>
      </div>
    </div>

    <!-- ---------- process flow ---------- -->
    <ol class="eco__proc" [@stepsIn]="viewState()" [@.disabled]="reduced">
      <li
        class="eco-step"
        *ngFor="let st of steps; trackBy: trackById; let i = index; let last = last"
      >
        <span class="eco-step__no" aria-hidden="true">0{{ i + 1 }}</span>
        <app-eco-card [card]="st" variant="step"></app-eco-card>
        <span class="eco__arrow" *ngIf="!last" aria-hidden="true">
          <svg viewBox="0 0 40 12" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M1 6h32" stroke-dasharray="4 4" />
            <path d="m30 2 5 4-5 4" />
          </svg>
        </span>
      </li>
    </ol>

    <!-- ---------- trust bar ---------- -->
    <ul class="eco__trust" [@staggerIn]="viewState()" [@.disabled]="reduced">
      <li
        class="eco-trust eco-stagger"
        *ngFor="let t of trust; trackBy: trackById"
        [attr.data-tone]="t.tone"
      >
        <span class="eco-trust__ico" aria-hidden="true">
          <app-eco-icon [name]="t.icon"></app-eco-icon>
        </span>
        <span class="eco-trust__tx">
          <strong>{{ t.lead }}</strong>
          <small>{{ t.label }}</small>
        </span>
      </li>
    </ul>
  </div>
</section>
